import { MrbBaseRouteStore } from "mrb/core";
import { LoadioArtistService, LoadioAlbumService } from "common/services";

class LoadioArtistPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(LoadioArtistService);
        this.albumService = rootStore.createApplicationService(LoadioAlbumService);
    }

    async getLoadioArtist(id) {
        const response = await this.service.get(id, {
            embed: "albums",
        });
        return response.data;
    }

    async updateActiveStatus(id, isActive) {
        const response = await this.service.updateActiveStatus(id, isActive);
        return response.data;
    }

    async updateAlbumActiveStatus(id, isActive) {
        const response = await this.albumService.updateActiveStatus(id, isActive);
        return response.data;
    }
}

export default LoadioArtistPreviewRouteStore;
